import React from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';
import Button from '../button';
import { ButtonColor } from '../button/enum';
export default function TransferSort(props) {
    const { moveToUp = noop, moveToDown = noop, upArrowText = '', downArrowText = '', upActive, downActive, className, multiple, } = props;
    if (multiple) {
        const customUpClass = classNames(`${className}-custom-up-active`, {
            [`${className}-custom-up-disable`]: !upActive,
        });
        const customDownClass = classNames(`${className}-custom-down-active`, {
            [`${className}-custom-down-disable`]: !downActive,
        });
        return (React.createElement("div", { className: className },
            typeof upArrowText === 'string' ? (React.createElement(Button, { color: upActive ? ButtonColor.primary : ButtonColor.default, disabled: !upActive, onClick: moveToUp, icon: 'expand_less' }, upArrowText)) : (React.createElement("div", { className: customUpClass, onClick: upActive ? moveToUp : undefined }, upArrowText)),
            typeof downArrowText === 'string' ? (React.createElement(Button, { color: downActive ? ButtonColor.primary : ButtonColor.default, disabled: !downActive, onClick: moveToDown, icon: 'expand_more' }, downArrowText)) : (React.createElement("div", { className: customDownClass, onClick: downActive ? moveToDown : undefined }, downArrowText))));
    }
    return null;
}
